/**
 * @generated SignedSource<<4776e142157bd603c31643946acc4408>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AvatarEditorDeleteMutation$variables = {
  userLocator: string;
};
export type AvatarEditorDeleteMutation$data = {
  readonly deleteAvatar: any | null | undefined;
};
export type AvatarEditorDeleteMutation = {
  response: AvatarEditorDeleteMutation$data;
  variables: AvatarEditorDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userLocator"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userLocator",
        "variableName": "userLocator"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteAvatar",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AvatarEditorDeleteMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "AvatarEditorDeleteMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "08c438e785ca9cd37dcb37188e54980c",
    "id": null,
    "metadata": {},
    "name": "AvatarEditorDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation AvatarEditorDeleteMutation(\n  $userLocator: String!\n) {\n  deleteAvatar(userLocator: $userLocator)\n}\n"
  }
};
})();

(node as any).hash = "cd57516592ed65a1c5c77a4cd674c440";

export default node;
